import { render } from "./FileFolder.vue?vue&type=template&id=287a99be&scoped=true"
import script from "./FileFolder.vue?vue&type=script&lang=js"
export * from "./FileFolder.vue?vue&type=script&lang=js"

import "./FileFolder.vue?vue&type=style&index=0&id=287a99be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287a99be"]])

export default __exports__